import {
  CREATE_PARTICIPANT,
  CREATE_PARTICIPANT_SUCCESS,
  CREATE_PARTICIPANT_ERROR,
  UPDATE_PARTICIPANT_STATE,
  GET_PARTICIPANT_COLLECTION,
  GET_PARTICIPANT_COLLECTION_SUCCESS,
  GET_PARTICIPANT_COLLECTION_ERROR
} from "../actions";

export const getParticipantCollection = (participantCollectionId, parentCollectionIdOfParticipantCollection, relationOfNodeId) => ({
  type: GET_PARTICIPANT_COLLECTION,
  payload: { participantCollectionId, parentCollectionIdOfParticipantCollection, relationOfNodeId }
});

export const getParticipantCollectionSuccess = (participantCollection) => ({
  type: GET_PARTICIPANT_COLLECTION_SUCCESS,
  payload: participantCollection,
});

export const getParticipantCollectionError = (message) => ({
  type: GET_PARTICIPANT_COLLECTION_ERROR,
  payload: { message },
});

export const createParticipant = (nodeEdge, history,collectionItemId, overviewPageId) => ({
  type: CREATE_PARTICIPANT,
  payload: { nodeEdge, history, collectionItemId, overviewPageId }
});

export const createParticipantSuccess = (participantSaved) => ({
  type: CREATE_PARTICIPANT_SUCCESS,
  payload: participantSaved,
});

export const createParticipantError = (message) => ({
  type: CREATE_PARTICIPANT_ERROR,
  payload: { message },
});

export const updateParticipantState = (updatedValues) => ({
  type: UPDATE_PARTICIPANT_STATE,
  payload: { updatedValues }
});